<script lang="ts">
  let {
    count = 18,
    mode = 'float',
  }: { count?: number; mode?: 'float' | 'attract' } = $props()

  const motes = $derived(
    Array.from({ length: count }, () => ({
      size: 0.15 + Math.random() * 0.3,
      fromX: (Math.random() - 0.5) * 90,
      fromY: (Math.random() - 0.5) * 90,
      driftX: (Math.random() - 0.5) * 15,
      duration: 2.5 + Math.random() * 4,
      // Negative delays start the motes mid-flight, so the field is alive
      // immediately.
      delay: Math.random() * -6,
    })),
  )
</script>

<!-- A field of drifting light particles. 'attract' streams them into the
center (buildup), 'float' lets them rise (afterglow). -->
<div class="motes {mode}" aria-hidden="true">
  {#each motes as mote (mote)}
    <span
      class="mote"
      style:--size="{mote.size}rem"
      style:--from-x="{mote.fromX}vmin"
      style:--from-y="{mote.fromY}vmin"
      style:--drift-x="{mote.driftX}vmin"
      style:--duration="{mote.duration}s"
      style:--delay="{mote.delay}s"
    ></span>
  {/each}
</div>

<style lang="postcss">
  .motes {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
  }
  .mote {
    position: absolute;
    top: 50%;
    left: 50%;
    animation: var(--duration) linear var(--delay) infinite;
    border-radius: 50%;
    box-shadow: 0 0 0.5rem var(--reveal-hue);
    background: color-mix(in oklab, var(--reveal-hue) 85%, white);
    aspect-ratio: 1;
    width: var(--size);
    opacity: 0;
  }
  .float .mote {
    animation-name: mote-float;
  }
  .attract .mote {
    animation-name: mote-attract;
    animation-timing-function: ease-in;
  }
  @keyframes mote-float {
    0% {
      transform: translate(var(--from-x), 52vmin);
      opacity: 0;
    }
    10% {
      opacity: 0.8;
    }
    90% {
      opacity: 0.5;
    }
    100% {
      transform: translate(calc(var(--from-x) + var(--drift-x)), -52vmin);
      opacity: 0;
    }
  }
  @keyframes mote-attract {
    0% {
      transform: translate(var(--from-x), var(--from-y)) scale(1);
      opacity: 0;
    }
    25% {
      opacity: 0.9;
    }
    100% {
      transform: translate(0, 0) scale(0.25);
      opacity: 0;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .motes {
      display: none;
    }
  }
</style>
